import * as types from "./types";

function setAsignacionData(payload) {
  return { type: types.SET_COLEGIO_ACTIVIDAD_DATA, payload };
}

function resetAsignacionData() {
  return { type: types.RESET_COLEGIO_ACTIVIDAD_DATA };
}

function obtenerActividadesAsignadas(payload) {
  return { type: types.FETCH_ASIGNADAS, payload };
}

function cambiarActividadesAsignadas(payload) {
  return { type: types.CHANGE_ASIGNADAS, payload };
}

function eliminarActividadesAsignadas(payload) {
  return { type: types.REMOVE_ASIGNADAS, payload };
}

function resetActividadesAsignadas(payload) {
  return { type: types.RESET_ACTIVIDADES_ASIGNADAS, payload };
}

function obtenerAlumnosAsignados(payload) {
  return { type: types.FETCH_ALUMNOS_ASIGNADOS, payload };
}

function cambiarAlumnosAsignados(payload) {
  return { type: types.CHANGE_ALUMNOS_ASIGNADOS, payload };
}

function eliminarAlumnosAsignados(payload) {
  return { type: types.REMOVE_ALUMNOS_ASIGNADOS, payload };
}

function resetAlumnosAsignados(payload) {
  return { type: types.RESET_ALUMNOS_ASIGNADOS };
}

/*---*/
export {
  setAsignacionData,
  resetAsignacionData,
  obtenerActividadesAsignadas,
  cambiarActividadesAsignadas,
  eliminarActividadesAsignadas,
  resetActividadesAsignadas,
  obtenerAlumnosAsignados,
  cambiarAlumnosAsignados,
  eliminarAlumnosAsignados,
  resetAlumnosAsignados
};



// WEBPACK FOOTER //
// ./src/ducks/asignaciones/actions.js